




































































import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';
import { types } from '../../api_types';
import * as ui from '../../ui';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faEdit,
  faExclamationTriangle,
  faEyeSlash,
  faBan,
  faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';
library.add(
  faExclamationTriangle,
  faEdit,
  faEyeSlash,
  faBan,
  faExternalLinkAlt,
);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class ProblemSettingsSummary extends Vue {
  @Prop() problem!: types.ArenaProblemDetails;
  @Prop({ default: null }) problemsetTitle!: null | string;
  @Prop({ default: false }) showVisibilityIndicators!: boolean;
  @Prop({ default: false }) showEditLink!: boolean;

  T = T;

  get title(): string {
    if (this.showVisibilityIndicators) {
      return ui.formatString(T.problemSettingsSummaryTitleWithProblemId, {
        problem_id: this.problem.problem_id,
        problem_title: this.problem.title,
      });
    }
    if (this.problem.letter && this.problemsetTitle) {
      return ui.formatString(
        T.problemSettingsSummaryTitleWithProblemsetTitleAndLetter,
        {
          problemset_title: this.problemsetTitle,
          letter: this.problem.letter,
          problem_title: this.problem.title,
        },
      );
    }
    if (this.problem.letter && !this.problemsetTitle) {
      return ui.formatString(T.problemSettingsSummaryTitleWithLetter, {
        letter: this.problem.letter,
        problem_title: this.problem.title,
      });
    }
    return this.problem.title;
  }

  get memoryLimit(): string {
    if (!this.problem.settings?.limits.MemoryLimit) {
      return '';
    }
    if (typeof this.problem.settings?.limits.MemoryLimit === 'string') {
      return this.problem.settings?.limits.MemoryLimit;
    }
    const memoryLimit = this.problem.settings?.limits.MemoryLimit as number;
    return `${memoryLimit / 1024 / 1024} MiB`;
  }

  get timeLimit(): string {
    if (!this.problem.settings?.limits.TimeLimit) {
      return '';
    }
    return `${this.problem.settings?.limits.TimeLimit}`;
  }

  get overallWallTimeLimit(): string {
    if (!this.problem.settings?.limits.OverallWallTimeLimit) {
      return '';
    }
    return `${this.problem.settings?.limits.OverallWallTimeLimit}`;
  }

  get inputLimit(): string {
    if (!this.problem.input_limit) {
      return '';
    }
    return `${this.problem.input_limit / 1024} KiB`;
  }
}
